import { render, staticRenderFns } from "./DelayForm.vue?vue&type=template&id=5bb61ede&scoped=true"
import script from "./DelayForm.vue?vue&type=script&lang=js"
export * from "./DelayForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb61ede",
  null
  
)

export default component.exports